import StoreMappingLoader from './StoreMappingLoader.container';

export default StoreMappingLoader;
